<template>
  <div
    class="app-root"
    :class="{
      'app-root--toolbar': showTopBar,
      'app-root--bottom': showBottomBar,
    }"
  >
    <ToolbarComp v-if="showTopBar" />
    <result-message />
    <main class="admin-main">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
    <LoaderComp v-if="isLoading" />
    <BottomBar v-if="showBottomBar" />
  </div>
</template>

<script>

    import {mapGetters} from 'vuex'
    import ToolbarComp from '@/components/ToolbarComp'
    import LoaderComp from '@/components/LoaderComp'
    import ResultMessage from '@/components/ResultMessage'
    import BottomBar from '@/components/BottomBar'

export default {
  name: 'app',
  components: {
    ToolbarComp, LoaderComp, ResultMessage, BottomBar
  },
  computed: {
             showBottomBar: function () {
                const dontShowIn = ['login','intro', 'select-turno', 'select-vehicle'];
                return dontShowIn.indexOf(this.$route.name) === -1;
            },
             showTopBar: function () {
                const dontShowIn = ['login','intro'];
                return dontShowIn.indexOf(this.$route.name) === -1;
            },
             ...mapGetters({
                isLoading: 'form/is-submiting'
            })
        }
  }


</script>

<style>
.app-root {
  min-height: 100vh;
}

/* Espacio bajo barra superior fija (altura toolbar ~3.5rem) */
.app-root--toolbar {
  padding-top: 3.75rem;
}

.p-button-secondary {
  color: white !important;
  background: #1e3a5f !important;
  border: 1px solid #334155 !important;
}

.p-button.p-button-success.google-success {
  background: #0F9D58;
  border-color: #0F9D58;
}

.p-button.p-button-success.google-success:enabled:hover {
  background: #0b8043;
  border-color: #0b8043;
}

.p-button.p-button-success.google-success:enabled:active {
  background: #0a7e3e;
  border-color: #0a7e3e;
}

.p-button.p-button-success.google-success:enabled:focus {
  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #0F9D58, 0 1px 2px 0 black;
}

</style>